<section *ngIf="!isLoading" class="zk-flex zk-flex-wrap">
	<div class="zk-w-full zk-mb-6">
		<div class="zk-w-fit-content">
			<h1 class="zk-text-1">
				{{ 'MY_ACCOUNT.PLAN_SESSION.FORM.GENERAL_CONFIG.TITLE' | translate }}
			</h1>
		</div>
	</div>
	<!-- Column 1 -->
	<div class="zk-w-full zk-mb-12">
		<div class="zk-mb-10">
			<label class="zk-flex zk-items-center">
				<input
					zkCheckbox
					[attr.disabled]="null"
					[zkHasError]="false"
					type="checkbox"
					[checked]="!data.blockNewClients"
					(change)="onChangeForm('blockNewClients', !data.blockNewClients)"
					style="margin-top: 0"
				/>
				<h3 class="zk-ml-2 zk-mr-1 zk-text-2">
					{{
						'MY_ACCOUNT.PLAN_SESSION.FORM.ACCEPT_NEW_CLIENTS.LABEL' | translate
					}}
				</h3>
				<div
					freud-tooltip
					[tooltipLabel]="
						'MY_ACCOUNT.PLAN_SESSION.FORM.ACCEPT_NEW_CLIENTS.INFO' | translate
					"
				>
					<img src="/assets/icons/menu/info.svg" alt="info" />
				</div>
			</label>
		</div>

		<div
			class="
				zk-pb-8 zk-flex zk-flex-row
				md:zk-flex-row
				sm:zk-flex-col
				margin-schedule-container
			"
		>
			<div class="zk-mr-6 zk-w-full zk-mb-5 md:zk-mb-0">
				<div class="zk-flex zk-mb-5">
					<h2 class="zk-text-2 zk-mr-1">
						{{
							'MY_ACCOUNT.PLAN_SESSION.FORM.MARGIN_TO_SCHEDULE.TITLE'
								| translate
						}}
					</h2>
					<div
						freud-tooltip
						tooltipLabel="{{
							'MY_ACCOUNT.PLAN_SESSION.FORM.MARGIN_TO_SCHEDULE.INFO.START'
								| translate
						}}"
					>
						<img src="/assets/icons/menu/info.svg" alt="info" />
					</div>
				</div>
				<zk-dropdown
					label="{{
						'MY_ACCOUNT.PLAN_SESSION.FORM.MARGIN_TO_SCHEDULE.LABEL' | translate
					}}"
					[value]="toString(data.marginInMinutesToSchedule)"
					[options]="marginOptions"
					name="marginInMinutesToSchedule"
					[zkStatus]="'info'"
					(change)="onChangeForm('marginInMinutesToSchedule', $event)"
				>
				</zk-dropdown>
			</div>

			<div class="zk-w-full">
				<div class="zk-flex zk-mb-5">
					<h2 class="zk-text-2 zk-mr-1">
						{{
							'MY_ACCOUNT.PLAN_SESSION.FORM.MARGIN_TO_RESCHEDULE.TITLE'
								| translate
						}}
					</h2>
					<div
						freud-tooltip
						tooltipLabel="{{
							'MY_ACCOUNT.PLAN_SESSION.FORM.MARGIN_TO_RESCHEDULE.INFO'
								| translate
						}}"
					>
						<img src="/assets/icons/menu/info.svg" alt="info" />
					</div>
				</div>
				<zk-dropdown
					label="{{
						'MY_ACCOUNT.PLAN_SESSION.FORM.MARGIN_TO_RESCHEDULE.LABEL'
							| translate
					}}"
					[value]="toString(data.marginInMinutesToReschedule)"
					[options]="marginOptions"
					name="marginInMinutesToReschedule"
					[zkStatus]="'info'"
					(change)="onChangeForm('marginInMinutesToReschedule', $event)"
				>
				</zk-dropdown>
			</div>
		</div>

		<div class="zk-w-1/2 md:zk-w-1/2 sm:zk-w-full">
			<h2 class="zk-text-2 zk-pb-5">
				{{ 'MY_ACCOUNT.PLAN_SESSION.FORM.TIMEZONE.LABEL' | translate }}
			</h2>
			<zk-dropdown
				label="{{
					'MY_ACCOUNT.PLAN_SESSION.FORM.TIMEZONE.LABEL_INPUT' | translate
				}}"
				[value]="data.timezone"
				[options]="timezoneOptions"
				name="timezone"
				[zkStatus]="'info'"
				(change)="onChangeForm('timezone', $event)"
			>
			</zk-dropdown>
		</div>

		<div class="zk-w-fit-content zk-mt-6">
			<label class="zk-flex zk-items-center">
				<input
					zkCheckbox
					[attr.disabled]="null"
					[zkHasError]="false"
					type="checkbox"
					[checked]="data.acceptOnlyWholeHour"
					(change)="onChangeForm('acceptOnlyWholeHour', !data.acceptOnlyWholeHour)"
					style="margin-top: 0"
				/>
				<h3 class="zk-ml-2 zk-mr-1 zk-text-2">
					{{
						'MY_ACCOUNT.PLAN_SESSION.FORM.SCHEDULE_FULL_HOURS.LABEL' | translate
					}}
				</h3>
				<div
					freud-tooltip
					[tooltipLabel]="
						'MY_ACCOUNT.PLAN_SESSION.FORM.SCHEDULE_FULL_HOURS.INFO' | translate
					"
				>
					<img src="/assets/icons/menu/info.svg" alt="info" />
				</div>
			</label>
		</div>
	</div>

	<freud-button
		[loading]="isSaving"
		[disabled]="!this.formChanged"
		(click)="saveForm()"
	>
		{{ 'MY_ACCOUNT.PLAN_SESSION.FORM.SUBMIT_BUTTON' | translate }}
	</freud-button>
</section>

<section *ngIf="isLoading" class="zk-flex zk-justify-center zk-py-5">
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</section>

<zk-dialog [(isOpen)]="isOpenModal" [clickOverlayCloses]="false">
	<ng-container zk-dialog-header>
		<h1
			*ngIf="
				modalStep === 'UPDATE_50_MIN_PRICE' ||
				modalStep === 'UPDATE_30_MIN_PRICE'
			"
			class="zk-text-white-base"
		>
			{{
				'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.HEADER'
					| translate
			}}
		</h1>

		<h1
			*ngIf="
				modalStep === 'CONFIRM_50_MIN_PRICE' ||
				modalStep === 'CONFIRM_30_MIN_PRICE'
			"
			class="zk-text-white-base"
		>
			{{
				'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.HEADER'
					| translate
			}}
		</h1>
	</ng-container>

	<ng-container zk-dialog-body>
		<div class="dialog-content">
			<div
				class="update"
				*ngIf="
					modalStep === 'UPDATE_50_MIN_PRICE' ||
					modalStep === 'UPDATE_30_MIN_PRICE'
				"
			>
				<h1>
					{{
						'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.TITLE'
							| translate
					}}
				</h1>
				<h2>
					{{
						'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.SUBTITLE'
							| translate
					}}
				</h2>

				<ul class="zk-mb-7 zk-pl-6">
					<li>
						{{
							'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.ITEM_1'
								| translate
						}}
					</li>
					<li *ngIf="modalStep === 'UPDATE_50_MIN_PRICE'">
						{{
							'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.ITEM_2'
								| translate
						}}
					</li>
				</ul>

				<h2 class="zk-pb-1">
					{{
						'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.FIELD_LABEL'
							| translate
					}}
				</h2>

				<zk-currency-input
					[value]="getModalPrice()"
					variant="enabled-focus"
					buttonVariant="hidden"
					(change)="setModalPrice($event)"
					[status]="modalError ? 'error' : 'default'"
					[message]="modalError"
				>
				</zk-currency-input>
			</div>

			<div
				class="zk-flex zk-flex-col zk-items-center zk-text-center"
				*ngIf="
					modalStep === 'CONFIRM_50_MIN_PRICE' ||
					modalStep === 'CONFIRM_30_MIN_PRICE'
				"
			>
				<p class="zk-pb-4">
					{{
						'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.TITLE'
							| translate
								: {
										value: modalStep === 'CONFIRM_50_MIN_PRICE' ? 50 : 30
								  }
					}}
				</p>

				<zk-currency-input
					[value]="getModalPrice()"
					variant="readonly"
					buttonVariant="hidden"
					(change)="setModalPrice($event)"
				></zk-currency-input>
			</div>
		</div>
	</ng-container>

	<ng-container zk-dialog-footer>
		<ng-container
			*ngIf="
				modalStep === 'UPDATE_50_MIN_PRICE' ||
				modalStep === 'UPDATE_30_MIN_PRICE'
			"
		>
			<button
				zk-button
				zkButtonColor="secondary"
				zkButtonSize="medium"
				(click)="leftButtonModal()"
				class="zk-mr-4"
			>
				{{
					'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.BUTTONS.CANCEL'
						| translate
				}}
			</button>
			<button
				zk-button
				zkButtonColor="primary"
				zkButtonSize="medium"
				(click)="rightButtonModal()"
			>
				{{
					'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.BUTTONS.SAVE'
						| translate
				}}
			</button>
		</ng-container>

		<ng-container
			*ngIf="
				modalStep === 'CONFIRM_50_MIN_PRICE' ||
				modalStep === 'CONFIRM_30_MIN_PRICE'
			"
		>
			<button
				zk-button
				zkButtonColor="secondary"
				zkButtonSize="medium"
				(click)="leftButtonModal()"
				class="zk-mr-4"
			>
				{{
					'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.BUTTONS.BACK'
						| translate
				}}
			</button>
			<button
				zk-button
				zkButtonColor="primary"
				zkButtonSize="medium"
				(click)="rightButtonModal()"
				[zkButtonLoading]="isSavingModal"
				style="width: 160px"
			>
				{{
					'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.BUTTONS.CONFIRM'
						| translate
				}}
			</button>
		</ng-container>
	</ng-container>
</zk-dialog>
